import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { publicAxios } from '@/lib/axios'
import { handleApiError, MutationConfig } from '@/lib/react-query'
import { PublicDto } from '@/types'

const registerUser = (data: PublicDto['RegisterUserCommand']): Promise<PublicDto['AuthSessionDto']> => {
  return publicAxios.post('/auth/register', data)
}

type UseRegisterUserOptions = {
  config?: MutationConfig<typeof registerUser>
}

export const useRegisterUser = ({ config }: UseRegisterUserOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: registerUser,
    onSuccess: (data, vars, onRes, ctx) => {
      config?.onSuccess?.(data, vars, onRes, ctx)
    },
    onError: (error: AxiosError<PublicDto['ExceptionDetails']>, vars, onRes, ctx) => {
      handleApiError(error)
      config?.onError?.(error, vars, onRes, ctx)
    },
  })
}
